import Chart from "react-apexcharts";
import { colors } from "../../../global";

const EffortDistribution = ({ data }) => {
  const colorPalette = [
    colors.primary,
    colors.secondary,
    colors.accent,
    colors.darkGray,
    colors.info,
    colors.warning,
    colors.error,
    colors.lightAccent,
    colors.mutedBlue,
    colors.success,
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <Chart
        key={JSON.stringify(data)}
        options={{
          chart: {
            type: "pie",
            toolbar: { show: false },
          },

          labels: data.labels,

          colors: colorPalette.slice(0, data.series.length),

          legend: {
            position: "bottom",
            fontSize: "14px",
            formatter: (label, opts) => {
              const value = opts.w.globals.series[opts.seriesIndex];
              return `${label}: ${value} Tickets`;
            },
          },

          dataLabels: {
            enabled: true,
            style: {
              fontSize: "14px",
              fontWeight: "600",
            },
            formatter: (val, opts) => {
              const value = opts.w.globals.series[opts.seriesIndex];
              return `${val.toFixed(1)}% (${value})`;
            },
          },

          tooltip: {
            y: {
              formatter: (val) => `${val} Tickets`,
            },
          },

          plotOptions: {
            pie: {
              expandOnClick: true,
              donut: {
                size: "0%",
              },
            },
          },

          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: { width: 300 },
                legend: { position: "bottom" },
              },
            },
          ],
        }}
        series={data.series}
        type="pie"
        height={350}
      />
    </div>
  );
};

export default EffortDistribution;
